import { Component } from '@angular/core';
import { Bookmark } from 'src/app/model/header/bookmark';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent {
  public bookmarks: Bookmark[] = [];
  
  ngOnInit() {
    let data = localStorage.getItem(AuthService.userBookmarksKey)!;
    if(data != null){
      this.bookmarks = JSON.parse(data || '[]')
    }
  }
}